import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-grid-cars-controls__wrap" }
const _hoisted_2 = { class: "o-container -full" }
const _hoisted_3 = { class: "c-grid-cars-controls" }
const _hoisted_4 = { class: "c-grid-cars-controls__left" }
const _hoisted_5 = { class: "c-grid-cars-filter-closed" }
const _hoisted_6 = { class: "c-showroom-2025-toggle__closed" }
const _hoisted_7 = { class: "c-showroom-2025-toggle__opened" }
const _hoisted_8 = { class: "c-grid-cars-controls__right" }
const _hoisted_9 = { class: "c-grid-cars-controls__keywords" }
const _hoisted_10 = { class: "c-cars-sidebar__wrap" }
const _hoisted_11 = { class: "c-cars-sidebar" }
const _hoisted_12 = { class: "c-cars-sidebar__inner" }
const _hoisted_13 = { class: "c-cars-sidebar__group" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_svgIco = _resolveComponent("svgIco")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "o-button-filters-toggle",
                onClick: _cache[0] || (_cache[0] = $event => {$options.toggle();})
              }, [
                _createElementVNode("span", _hoisted_6, [
                  _createVNode(_component_svgIco, { icon: "cars-filters" }),
                  _cache[3] || (_cache[3] = _createTextVNode(" Filtrer "))
                ]),
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_svgIco, { icon: "close" })
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.selectedMakes, (make) => {
                return (_openBlock(), _createElementBlock("span", {
                  class: "o-button-cars-filter",
                  key: make
                }, [
                  _createTextVNode(_toDisplayString(make) + " ", 1 /* TEXT */),
                  _createElementVNode("button", null, [
                    _createVNode(_component_svgIco, {
                      icon: "close",
                      onClick: $event => ($options.remove(make))
                    }, null, 8 /* PROPS */, ["onClick"])
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              ($data.selectedMakes.length)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "c-button-cars-filter-reset o-button",
                    onClick: _cache[1] || (_cache[1] = $event => ($options.reset()))
                  }, [
                    _createVNode(_component_svgIco, { icon: "trash" })
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[4] || (_cache[4] = _createElementVNode("h3", { class: "c-cars-sidebar__title" }, "Marques", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.makes, (make) => {
              return (_openBlock(), _createElementBlock("label", {
                class: "c-cars-sidebar__label",
                key: make
              }, [
                _createElementVNode("input", {
                  type: "checkbox",
                  onClick: _cache[2] || (_cache[2] = (...args) => ($options.toggleMake && $options.toggleMake(...args)))
                }),
                _createElementVNode("span", null, _toDisplayString(make), 1 /* TEXT */)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ])
        ])
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}